import { render, staticRenderFns } from "./AddOrUpdatePersonnel.vue?vue&type=template&id=1f730be4&scoped=true&"
import script from "./AddOrUpdatePersonnel.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdatePersonnel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f730be4",
  null
  
)

export default component.exports